// plugins/auto-img-default.js
export default function () {
  if (process.client) {
    const fallbackImg = 'https://download-pa-s3.thethinkacademy.com/picture/415/20250825/1756100819068rY7Nu0r1dF.webp'

    const failedSrcSet = new WeakSet()

    document.addEventListener(
      'error',
      (e) => {
        const { target } = e
        if (target.tagName !== 'IMG') return

        if (!target.dataset.errorHandled) {
          target.dataset.errorHandled = 'true'

          // 避免死循环：同一个 img 对象再次触发时直接跳过
          if (failedSrcSet.has(target)) return
          failedSrcSet.add(target)

          target.src = fallbackImg
        }
      },
      true,
    )
  }
}
